import { render } from "./DebugFrage.vue?vue&type=template&id=0eae0292&ts=true"
import script from "./DebugFrage.vue?vue&type=script&lang=ts"
export * from "./DebugFrage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__